exports = module.exports = require("../../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".try-service[data-v-f82ba79a] {\n  display: inline-flex;\n  align-items: center;\n  flex-direction: column;\n}\n.try-service .try-service__button[data-v-f82ba79a] {\n  padding: 22px 36px;\n  font-size: 18px;\n  height: auto;\n}\n.try-service .try-service__info[data-v-f82ba79a] {\n  color: #00afa1;\n  line-height: 2;\n  letter-spacing: 1px;\n  text-transform: uppercase;\n}", ""]);

// exports
